import { type Dispatch, type SetStateAction, useEffect, useMemo } from "react"

import type { HomeRanking } from "@/types/homeTypes"

export default function RoundsFilter({
  data,
  setCurrentRound,
  currentRound,
}: {
  data: HomeRanking[]
  setCurrentRound: Dispatch<SetStateAction<number | undefined>>
  currentRound: number | undefined
}) {
  // Generate filters safely
  const filters = useMemo(() => {
    if (!data) return []
    return data.map((ele) => ({
      label: ele?.round_name,
      id: ele?.round_id,
    }))
  }, [data])

  // Set default round if none is selected
  useEffect(() => {
    if (!currentRound && data?.length) {
      setCurrentRound(data?.[0]?.round_id)
    }
  }, [currentRound, data, setCurrentRound])

  return (
    <div className="keys-con mb-4">
      {filters.map((ele, index) => (
        <button
          onClick={() => setCurrentRound(ele.id)}
          key={index}
          className={`${currentRound == ele.id && "active"}`}
        >
          {ele.label}
        </button>
      ))}
    </div>
  )
}
